import React, { FC, useEffect, useContext, useState } from 'react'
//import IdleTimer from 'react-idle-timer';
import { useIdleTimer } from 'react-idle-timer'
import { connect } from 'react-redux'
import { toast } from "react-toastify";
import { Button, Header, Icon, Modal, Popup } from 'semantic-ui-react';

import API, {ErrorManagement, ResponseManagement} from "../../API";
//import { useRouter } from '../../hooks/useRouter';
import useFromSelfCheckin from "../../hooks/useFromSelfCheckin";
import { RootDispatch, RootState } from '../../store';
import GlobalContext from '../../contexts/GlobalContext';
import Utility, { checkInErrorCodes } from '../../Utility';
import { handleCheckinData } from '../../store/checkin';
import {  useParams, useLocation, useNavigate } from 'react-router-dom';

import Box from '../../components/Box/Box';
import Page from '../../components/Page/Page';
import ModalSuccessPreCheckin from "../../components/PreCheckIn/successSelfCheckin/ModalSuccessSelfCheckin";
import Loader from '../../components/Basics/Loader';
import BookingRoomingDetailV2 from '../../components/PreCheckIn/BookingRoomingDetailV2';
import HeaderPreCheckin from '../../components/PreCheckIn/HeaderPreCheckin';
import ModalPreCheckIn from '../../components/PreCheckIn/ModalPreCheckInV2';
import ModalTransition from '../../components/ModalTransition/ModalTransition';

const mapProps = (state: RootState) => ({
  booking: state.booking,
  checkIn: state.checkin,
  modal: state.modal,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  loadBooking: dispatch.booking.load,
  loadCheckIn: dispatch.checkin.load,
  loadAccommodations: dispatch.accommodation.loaded,
  updateIsBookerPax: dispatch.booking.updateIsBookerPax,
  handleModal: dispatch.modal.handleModal
});

type Props = {} & ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

/** 
 * 
 */
const PreCheckInV2: FC<Props> = ({
  booking,
  checkIn,
  modal,
  loadBooking,
  loadAccommodations,
  loadCheckIn,
  updateIsBookerPax,
  handleModal
}) => {

  // States
  const [isLoading, setIsLoading] = useState(true)
  const [isDeleteLoading, setIsDeleteLoading] = useState(false)

  // Hooks call
  const globalContext = useContext(GlobalContext)[0];
  //const router          = useRouter()
  let { token, lang, id } = useParams();
  const location = useLocation();
  let navigate = useNavigate();

  const fromSelfCheckin = useFromSelfCheckin(location);

  const baseUri = `/${token}/${lang}`;

  // Chargement initial avec appel Ajax pour récupération des données
  useEffect(() => {
    //setIsRedirectState(false);
    const bookingFolderId = id
    const { isFromSelfCheckin, selfCheckinToken } = fromSelfCheckin

    API.post(Utility.getUrlAjax() + `/preCheckIn-${bookingFolderId}`, JSON.stringify({
      isFromSelfCheckin,
      selfCheckinToken,
      bookingFolderId,
    }))
    .then(res => {
      ResponseManagement(res,
        () => {
          const data = res.data.data
          const processedData = handleCheckinData(data);
          const bookingsCompletionRates = data?.completionRates?.byFolder?.[parseInt(bookingFolderId)]?.byBooking
          
          if( processedData.isMailValid == false && processedData.isFromSelfCheckin == false && typeof processedData.newToken != 'undefined' ){
            //baseUri = `/${processedData.newToken}/${lang}`;
            //router.push(`/${processedData.newToken}/${lang}/login/initializePassword`)
            navigate(
              `/${processedData.newToken}/${lang}/login/initializePassword`
            );
          }
          //handleReloadData(processedData);
          loadBooking({
            bookings: processedData?.bookings ?? [],
            bookingsCompletionRates: bookingsCompletionRates ?? {},
            bookingFolder: processedData.bookingFolder,
          });
          loadAccommodations({
            accommodationServicesList: processedData.accommodationServices
          })
          loadCheckIn({
            checkInFieldParameters: processedData?.checkInFieldParameters ?? {},
            completionRates: data?.completionRates ?? {}
          })
          if (processedData?.isBookerPax) {
            updateIsBookerPax(processedData.isBookerPax);
          }
          
        },
        () => {
          toast.error(globalContext.translations?.[res?.data?.message] ?? 'Data loading error');

          if (globalContext.authenticationStatus == 1) {
            // Redirect to dashboard
            //router.push({ pathname: baseUri, state: { from: location } })
            navigate(
              baseUri,
              {
                state: { from: location }
              }
            );
          } else {
            checkInErrorCodes.includes(res.data.message)
              //? router.push(`${baseUri}/login`)
              ? navigate(`${baseUri}/login`)
              //: router.push('/')
              : navigate('/')
          }
        }
      );
    })
    .catch(error => {
      // Redirect to dashboard
      //ErrorManagement(error, () => router.push({ pathname: baseUri, state: { from: location } }));
      ErrorManagement(error, () => navigate( baseUri, {state: { from: location } } ) );
    })
    .finally(() => setIsLoading(false))
  }, [id]);

  // Remove from roomingList
  const handleConfirmDelete = () => {
    const bookingFolderId = id
    setIsDeleteLoading(true)
    const { isFromSelfCheckin } = fromSelfCheckin

    const dataToSend = {
      bookingId: checkIn.selected.bookingId,
      roomingListId: checkIn.selected.roomingListId,
      bookingFolderId,
      isFromSelfCheckin
    };

    /*API.post(Utility.getUrlAjax() + '/removePreCheckInAction', new URLSearchParams({
      bookingId: checkIn.selected.bookingId,
      roomingListId: checkIn.selected.roomingListId,
      bookingFolderId,
    }))*/
    API.post(Utility.getUrlAjax() + '/removePreCheckInAction', JSON.stringify(dataToSend))
    .then(res => {
      ResponseManagement(res,
        () => {
          const data = res.data.data;
          const processedData = handleCheckinData(data);
          const bookingsCompletionRates = data?.completionRates?.byFolder?.[parseInt(bookingFolderId)]?.byBooking

          if (processedData?.bookings) {
            loadBooking({
              bookings: processedData?.bookings ?? [],
              bookingsCompletionRates,
            });
            loadCheckIn({
              checkInFieldParameters: processedData?.checkInFieldParameters ?? {},
              completionRates: data?.completionRates ?? {}
            })
            updateIsBookerPax(processedData.isBookerPax);
            toast.success(globalContext.translations.preCheckInAlertDeleteSuccess);
          }          
        },
        () => {
          toast.error('Data sending error');
          // Redirect to dashboard
          //setTimeout(() => router.push({ pathname: baseUri, state: { from: location } }), 5500);
          setTimeout(() => navigate( baseUri, {state: { from: location } } ), 5500);
        }
      );
    })
    .catch(error => {
      console.error(error);
      // Redirect to dashboard
      //ErrorManagement(error, () => router.push({ pathname: baseUri, state: { from: location } }));
      ErrorManagement(error, () => navigate( baseUri, {state: { from: location } } ));
    })
    .finally(() => {
      handleModal({preCheckInConfirmModal: false})
      setIsDeleteLoading(false)
    })
  }

  const onIdle = () => {
    // Close Modal Prompt
    // Do some idle action like log out your user
    //router.push(`/${fromSelfCheckin.selfCheckinToken}`)
    navigate(`/${fromSelfCheckin.selfCheckinToken}`)
  }

  const idleTimer = useIdleTimer({  onIdle,
      startOnMount : false,
      debounce : 250,
  });

  /*{fromSelfCheckin.isFromSelfCheckin &&
    <IdleTimer
      element={document}
      onIdle={() => router.push(`/${fromSelfCheckin.selfCheckinToken}`)}
      debounce={250}
      timeout={ 2 * 1000 * 60}
    />
  }*/

  return (
    <>
      <Page location={location} history={navigate}>
        <Loader active={isLoading} />
        
        <Box header="">
          <div className={!fromSelfCheckin.isFromSelfCheckin ? "my-5" : ""}>
            <h3 className="title-mb" style={{display:'flex', padding: "0"}}>
              <HeaderPreCheckin 
                bookingFolder={booking.bookingFolder}
                completionRates={checkIn.completionRates}
              />
              {fromSelfCheckin.isFromSelfCheckin &&
                <Popup
                  content={globalContext.translations.disconnect}
                  trigger={
                    <Button
                      className="return-selfCheckin-action-container btnStyleDelete"
                      icon={<Icon size="big" name="sign-out alternate" />}
                      //onClick={() =>  router.push(`/${fromSelfCheckin.selfCheckinToken}`)}
                      onClick={() =>  navigate(`/${fromSelfCheckin.selfCheckinToken}`)}
                    />
                  }
                />
              }
            </h3>
          </div>
          <div id="cardPreCheckIn">
          {booking.bookings.map((booking) => (
              <BookingRoomingDetailV2 
                key={booking.id} 
                booking={booking} 
              />
            ))}
          </div>
        </Box>
      </Page>
      <ModalSuccessPreCheckin />
      <ModalPreCheckIn />
      <ModalTransition
        header={
          <Modal.Header>
            <Header>
              {globalContext.translations.deletionOfTheTenant}
            </Header>
          </Modal.Header>
        }
        content={`${globalContext.translations.preCheckInDeleteMessage} ?`}
        actions={
          <Modal.Actions>
            <Button 
              type="button"
              disabled={isDeleteLoading}
              onClick={() => handleModal({preCheckInConfirmModal: false})}
            >
              {globalContext.translations.preCheckInCancel}
            </Button>
            <Button 
              type="button"
              disabled={isDeleteLoading}
              loading={isDeleteLoading}
              onClick={() => handleConfirmDelete()} color="red"
            >
              {globalContext.translations.preCheckInDelete}
            </Button>
          </Modal.Actions>
        }
        open={modal.preCheckInConfirmModal}
        size="tiny"
        handleClose={() => handleModal({preCheckInConfirmModal: false})}
        closeOnDimmerClick={false}
      />
    </>
  )
}

export default connect(mapProps, mapDispatch)(PreCheckInV2)